import Component from "@glimmer/component";
import { task } from "ember-concurrency";
import { t } from "ember-intl";
import PageContent from "glesys-controlpanel/components/page-content";
import PageContentServiceIntro from "glesys-controlpanel/components/page-content/service-intro";
import DataLoader from "glesys-controlpanel/components/data-loader";
import EmptyState from "glesys-controlpanel/components/empty-state";
import Entity from "glesys-controlpanel/components/entity";
import GButtonLinkTo from "glesys-controlpanel/components/g-button/link-to";
import canManage from "glesys-controlpanel/helpers/can-manage";
import { and, not } from "ember-truth-helpers";
import { tracked } from "@glimmer/tracking";
import { on } from "@ember/modifier";
import modal from "glesys-controlpanel/helpers/modal";
import EntityField from "glesys-controlpanel/components/entity/fields/field";
import EntityDataCenterField from "glesys-controlpanel/components/entity/fields/data-center";
import EntityList from "glesys-controlpanel/components/entity-list";
import DropdownDestructiveItem from "glesys-controlpanel/components/dropdown/destructive-item";
import { array } from "@ember/helper";
import IconsSidebarStorage from "glesys-controlpanel/components/icons/sidebar/storage";

export default class DatabasesOverview extends Component {
  @tracked databases;

  loadDatabases = task(async () => {
    this.databases = await this.args.model.project.get("databases");
  });

  <template>
    <PageContent>
      <PageContentServiceIntro @title={{t "databases.overview.page-title"}}>
        {{#if (and (canManage) this.databases)}}
          <GButtonLinkTo data-test-databases-create @route="databases.create" @color="green">
            {{t "label.create"}}
          </GButtonLinkTo>
        {{/if}}
      </PageContentServiceIntro>
      <DataLoader @load={{this.loadDatabases}}>
        <EntityList @items={{this.databases}}>
          <:default as |database|>
            <Entity
              @route="databases.details"
              @model={{database.id}}
              @title={{database.name}}
              @key={{database.id}}
              @linkLabel={{t "databases.manage-database-aria-label" name=database.name}}
              @hideActions={{not (canManage)}}
            >
              <:fields>
                <EntityDataCenterField @dataCenter={{database.datacenterkey}} />
                <EntityField data-test-database-engine @label={{t "label.engine"}}>
                  {{database.normalizedEngineName}}
                  {{database.engineversion}}
                </EntityField>
              </:fields>
              <:actions>
                <DropdownDestructiveItem
                  data-test-database-delete
                  {{on
                    "click"
                    (modal
                      "modals/organism-delete"
                      entity=database.name
                      task=database.deleteTask
                      entityKey=database.id
                      leadText=(t "databases.delete-warning")
                    )
                  }}
                >
                  {{t "button.delete"}}
                </DropdownDestructiveItem>
              </:actions>
            </Entity>
          </:default>
          <:empty>
            <EmptyState
              @icon={{IconsSidebarStorage}}
              @title={{t "databases.overview.empty-state.title"}}
              @description={{t "databases.overview.empty-state.description"}}
              @points={{array
                (t "databases.overview.empty-state.usp-list.automated-backups")
                (t "databases.overview.empty-state.usp-list.multiple-databases-and-users")
                (t "databases.overview.empty-state.usp-list.built-in-firewall")
              }}
              @learnMoreUrl="https://docs.glesys.com/products/database"
              @learnMoreAriaLabel={{t "databases.overview.empty-state.learn-more-aria-label"}}
              @createRoute={{if (canManage) "databases.create"}}
              @createLabel={{t "databases.overview.empty-state.button-create"}}
            />
          </:empty>
        </EntityList>
      </DataLoader>
    </PageContent>
  </template>
}
